<template>
        <v-container>
        <v-card
        class="mx-auto"
        width="100%"
        >

        <v-list v-if="!loading" two-line subheader>
            <v-list-item
            v-for="item in shownTreatments"
            :key="item.id"
            >

            <v-list-item-content>
                <v-list-item-title v-text="item.data.title"></v-list-item-title>
                <v-list-item-subtitle v-text="`by ${item.data.ownerName} | ${item.data.dateAdded}`"></v-list-item-subtitle>
            </v-list-item-content>
            
            <v-spacer></v-spacer>

            <v-list-item-content>
                <v-list-item-subtitle v-text="`${item.data.category}`"></v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action>
                <v-btn icon @click.stop="viewTreatment(item)">
                    <v-icon color="grey lighten-1">mdi-information</v-icon>
                </v-btn>
            </v-list-item-action>
            </v-list-item>
        </v-list>

        <v-progress-circular
        v-if="loading"
        color="primary"
        indeterminate
        :size="64"
        ></v-progress-circular>

        </v-card>
        
        <v-dialog v-model="viewTreatmentDialog" :retain-focus="false" fullscreen hide-overlay persistent transition="dialog-bottom-transition">
            <view-treatment-screen-popup 
            v-if="viewTreatmentDialog"
            v-on:dialogClosed="closeViewTreatment()"
            :treatment="currentShownTreatment.data"
            :treatmentId="currentShownTreatment.id"
            :uid="uid"
            :showToolbar="true">
            </view-treatment-screen-popup>
        </v-dialog>
    </v-container>
</template>

<script>
import ViewTreatmentScreenPopup from './../Popups/ViewTreatmentScreenPopup.vue'
import TreatmentDataService from './../../../services/treatmentDataService.js';
import Toast from './../../../plugins/customToast.js';
import debounce from './../../../plugins/debounce.js'

  export default {
    data () {
      return {
        viewTreatmentDialog: false,
        currentShownTreatment: {},
        treatmentService: null,
        filterOptions: {
            sortBy: "Newest",
            categories: [],
            searchTerm: null,
            pageSize: 10,
            isPublic: null,
            organisation: null,
            owner: null
        },
        localTreatmentSnapshots: [],
        currentPage: 0,
        loading: false,
      }
    },
    components: {
        ViewTreatmentScreenPopup
    },
    props: 
    {
      sort: String,
      isPublic: Boolean,
      pageSize: Number,
      categories: Array,
      uid: String,
      currentCollectionSelected: String
    },
    methods: {
        closeViewTreatment() {
            this.viewTreatmentDialog = false;
        },
        viewTreatment(item) {
            if (item.id != null){
                this.currentShownTreatment = item;
                console.log("Viewing Treatment Item: " + item.data.title + " by " + item.data.ownerName) // eslint-disable-line no-console
                this.viewTreatmentDialog = true;
            }
        },
        firstPageLoad(){
            this.loading = true;

            this.treatmentService.firstPaginatedPage('treatments', this.currentCollectionSelected, this.filterOptions)
            .then((treatments) => {
                this.localTreatmentSnapshots = treatments;
                //Reset the pagination counter
                this.currentPage = 0;
                this.loading = false;
            })
            .catch((error) => {
                Toast.fire({  icon: 'error',  title: `Error getting treatments: ${error.message}!`});
                console.log(error); //eslint-disable-line
                this.loading = false;
            });
        },
    },
    mounted(){
        this.treatmentService = new TreatmentDataService(this.$route.params.userDb);
        this.filterOptions.owner = this.$route.params.userDb.uid;
        this.filterOptions.organisation = this.$route.params.userDb.orgid;

        //Do the first page load
        this.firstPageLoad();
    },
    watch: {
        sort: {
            immediate: true,
            handler(val){
                if (val){
                    this.filterOptions.sortBy = val;
                }
            }
        },
        isPublic: {
            immediate: true,
            handler(val){
                this.filterOptions.isPublic = val;
            }
        },
        pageSize: {
            immediate: true,
            handler(val){
                if (val){
                    this.filterOptions.pageSize = val;
                }
            }
        },
        categories: {
            immediate: true,
            handler(val){
                if (val){
                    this.filterOptions.categories = val;
                }
            }
        },
        filterOptions: {
            // the callback won't be called immediately after the start of the observation
            immediate: false, 
            deep: true,
            handler () {
                //If our filter options change, repeat the firstPageLoad
                debounce(() => {
                    this.firstPageLoad();
                }, 500) ();
            }
        }
    },
    computed: {
        shownTreatments(){
            var treatmentItems = [];

            //Formatting the treatment snapshots into a presentable/showable treatmentItem format 
            if(this.localTreatmentSnapshots.length > 0) {
                this.localTreatmentSnapshots.forEach(doc => {
                    treatmentItems.push({id: doc.id, data: doc.data()});
                });
            }
            return treatmentItems;
        }
    }
  }
  </script>